import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  versionDate: "",
  newDownloadVersion: false,
  storeNameText: "",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setVersionDate(state, action) {
      state.versionDate = action.payload;
    },
    setNewDownloadVersion(state, action) {
      state.newDownloadVersion = action.payload;
    },
    setStoreNameText(state, action) {
      state.storeNameText = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setVersionDate, setNewDownloadVersion, setStoreNameText } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
